import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'tinycolor2';
import throwOnUndefinedProperty from '../../utils/throwOnUndefinedProperty/index.js';
import '../../utils/shouldShowForEnvironment/index.js';
import BREAKPOINTS from '../breakpoints/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var mediaQueries = Object.entries(BREAKPOINTS).reduce((accumulator, _ref) => {
  var [label, px] = _ref;
  return _objectSpread(_objectSpread({}, accumulator), {}, {
    ["".concat(label, "Up")]: "@media (min-width: ".concat(px, "px)")
  });
}, {});
var MEDIA_QUERIES = throwOnUndefinedProperty(mediaQueries);

export { MEDIA_QUERIES as default };
